import { usePayJunctionOptionsGet } from "@/features/profile-settings/hooks";
import {
  getPayJunctionPublishableKey,
  hasPayJunctionPublishableKey,
} from "@/features/balance/utils/payjunction-options";

interface UsePayJunctionConfigResult {
  isPayJunctionEnabled: boolean;
  hasCredentials: boolean;
  publishableKey: string | null;
  isPayJunctionConfigured: boolean;
  isLoading: boolean;
}

export const usePayJunctionConfig = (tenantId: number): UsePayJunctionConfigResult => {
  const { data: pjOptions, isLoading } = usePayJunctionOptionsGet({ tenantId });

  const isPayJunctionEnabled = pjOptions?.enabled === true;
  const hasCredentials = !!pjOptions?.userName?.trim();
  const publishableKey = getPayJunctionPublishableKey(pjOptions);
  const isPayJunctionConfigured =
    isPayJunctionEnabled && hasCredentials && hasPayJunctionPublishableKey(pjOptions);

  return {
    isPayJunctionEnabled,
    hasCredentials,
    publishableKey,
    isPayJunctionConfigured,
    isLoading,
  };
};
